import { render, staticRenderFns } from "./ProductReviewReg.vue?vue&type=template&id=b3dbe9c6&scoped=true"
import script from "./ProductReviewReg.vue?vue&type=script&lang=js"
export * from "./ProductReviewReg.vue?vue&type=script&lang=js"
import style0 from "./ProductReviewReg.vue?vue&type=style&index=0&id=b3dbe9c6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3dbe9c6",
  null
  
)

export default component.exports